"use client";
/**
 * Adds a prefetch link to the document head.
 * @param {string} kind - The rel attribute of the link (e.g., "prefetch", "preload").
 * @param {string} url - The URL to prefetch.
 * @param {string} [as] - The as attribute of the link (e.g., "image", "script").
 */
export const addPrefetch = (kind, url, as) => {
    const linkElem = document.createElement("link");
    linkElem.rel = kind;
    linkElem.href = url;
    if (as) {
        linkElem.as = as;
    }
    linkElem.crossOrigin = "true";
    document.head.append(linkElem);
};
